import { LuPin, LuPinOff } from "react-icons/lu";
import { colors } from "../../../design/tokens";
import {
  SideMenuBehavior,
  useSideMenuActions,
  useSideMenuBehavior,
} from "../../../view_stores/useSideMenuStore";

const ICON_SIZE = 20;
const ICON_ROTATION = "rotate-[30deg]";

export default function SideMenuPinBtn(): JSX.Element {
  const sideMenuBehavior = useSideMenuBehavior();
  const { switchBehavior } = useSideMenuActions();

  const isPinned = sideMenuBehavior === SideMenuBehavior.PINNED;
  const Icon = isPinned ? LuPinOff : LuPin;

  return (
    <div className="w-full flex justify-end">
      <button
        onClick={switchBehavior}
        className={`py-2.5 pl-3.5 pr-2.5 rounded-s-full
          text-dark-text-muted ${colors.surface.secondary}
          hover:text-dark-text ${colors.hover.backgroundAlt}
          transition-colors duration-200`}
      >
        <Icon size={ICON_SIZE} className={ICON_ROTATION} />
      </button>
    </div>
  );
}
